var _rect, _path, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 14,
    height: 12,
    rx: 1,
    transform: "rotate(-180 15 15)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96679 13C7.35424 13 6.82288 12.895 6.37269 12.685C5.92989 12.4749 5.5941 12.1974 5.36531 11.8523C5.13653 11.5073 5.01476 11.136 5 10.7384V10.7159C5 10.6559 5.02214 10.6071 5.06642 10.5696C5.11808 10.5246 5.17343 10.5021 5.23247 10.5021H6.28413C6.45387 10.5021 6.56089 10.5771 6.60517 10.7271C6.70849 11.0572 6.87823 11.301 7.11439 11.4585C7.35793 11.616 7.64207 11.6948 7.96679 11.6948C8.38007 11.6948 8.71956 11.5673 8.98524 11.3122C9.2583 11.0572 9.39483 10.7046 9.39483 10.2546C9.39483 9.84951 9.2583 9.52321 8.98524 9.27567C8.71956 9.02063 8.38007 8.89311 7.96679 8.89311C7.74539 8.89311 7.56458 8.92311 7.42435 8.98312C7.28413 9.04313 7.1476 9.12564 7.01476 9.23066C7 9.23816 6.96679 9.26067 6.91513 9.29817C6.86347 9.33568 6.8155 9.36193 6.77122 9.37693C6.73432 9.39194 6.69373 9.39944 6.64945 9.39944H5.60886C5.54244 9.39944 5.48339 9.37693 5.43173 9.33193C5.38745 9.27942 5.36531 9.21941 5.36531 9.1519L5.7417 5.31505C5.74908 5.21753 5.78229 5.14252 5.84133 5.09001C5.90775 5.03 5.98524 5 6.0738 5H10.2362C10.3173 5 10.3801 5.02625 10.4244 5.07876C10.476 5.12377 10.5018 5.18753 10.5018 5.27004V6.03516C10.5018 6.11017 10.476 6.17393 10.4244 6.22644C10.3801 6.27895 10.3173 6.3052 10.2362 6.3052H7.0369L6.85978 8.12799C7.02952 8.01547 7.22509 7.92546 7.44649 7.85795C7.6679 7.78293 7.95572 7.74543 8.30996 7.74543C8.78967 7.74543 9.23247 7.85045 9.63838 8.06048C10.0517 8.26301 10.3801 8.55931 10.6236 8.94937C10.8745 9.33193 11 9.77825 11 10.2883C11 10.8359 10.8745 11.316 10.6236 11.7286C10.3727 12.1336 10.0185 12.4487 9.56089 12.6737C9.10332 12.8912 8.57196 13 7.96679 13Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 2.75,
    width: 14.5,
    height: 12.5,
    rx: 2.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 5 0)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 4,
    height: 2,
    rx: 1,
    transform: "rotate(90 13 0)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive5);
export default __webpack_public_path__ + "static/media/archive-5.09951f2b098bf0787bef829b256e2c05.svg";
export { ForwardRef as ReactComponent };